<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-row>
      <v-col cols="12">
        <h1 class="text-h5 mb-6">{{ $t('Products') }}</h1>
      </v-col>
    </v-row>
    <products-table include-search />
  </v-container>
</template>

<script>
import Vue from 'vue'
import ProductsTable from '@/components/products/ProductsTable'

export default {
  metaInfo () {
    return { title: this.pageTitle }
  },

  components: {
    ProductsTable
  },

  data: () => ({
    pageTitle: Vue.i18n.translate('Products')
  }),

  methods: {
    reload () {
      this.$wait.start('fetching products')
      this.$store.dispatch('FETCH_PRODUCTS')
        .finally(() => this.$wait.end('fetching products'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/Index.vue